export const DEFAULT_CONTEXT = 'genesis';

export const OG_IMAGES = {
  HELP_CENTER: 'https://cdn.storymd.com/optimized/6qyW1JT5o1/original.jpg',
  POINT_OF_CARE: 'https://cdn.storymd.com/optimized/koXgQNtEA8/original.jpg',
  WHY_STORYMD: 'https://cdn.storymd.com/optimized/lNAletNor9/original.jpg',
  WELCOME: 'https://cdn.storymd.com/optimized/VYqG8i1Alk/original.jpg',
  EXPLORE: 'https://cdn.storymd.com/optimized/4AwLRgCroz/original.jpg',
};
